






























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Group } from '@/router/group.model';
import isMobile from '@/utils/mobile-check';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CollapseRowV2 from '@/componentsV2/molecules/CollapseRowV2/CollapseRowV2.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';

import LeftBarNavGroupHeader from './LeftBarNavGroupHeader.vue';
import LeftBarNavSubGroup from './LeftBarNavSubGroup.vue';
import LeftBarNavItem from './LeftBarNavItem.vue';
import { getCurrentGroup, getCurrentRoute } from '@/router';
import eventBus from '@/utils/eventBus';
import { getMenuIconName } from '@/utils/iconHelper';

@Component({
  components: {
    Typography,
    LeftBarNavItem,
    LeftBarNavSubGroup,
    CollapseRowV2,
    LeftBarNavGroupHeader,
    ArrowDownIcon
  }
})
export default class TopBarNavGroup extends Vue {
  @Prop() group!: Group;
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop({ default: false }) mobileTabs?: boolean;
  @Prop({ default: false }) collapsed?: boolean;
  @Prop({ default: false }) actived?: boolean;
  @Prop() focusedId?: string;
  @Prop() notification?: any;

  getMenuIconName = getMenuIconName;

  get isMobileDevice() {
    return isMobile();
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  getTranslatedLabel(group: Group) {
    const translatedLabel = this.$t(`menus.sidebar.group.${group.id}`);

    if (!translatedLabel) {
      return group.name;
    }

    return translatedLabel;
  }

  getRoutesAndGroups(group: Group) {
    const response = group.getVisibleRoutesAndGroup();
    return response.length > 1 ? response : [];
  }

  clickRoute(id: string) {
    this.$emit('click-route', id);
  }

  clickCollapse() {
    if (this.group.routes.length <= 1) {
      if (this.$mobileCheck()) {
        eventBus.$emit('toggleLeftBarMobile', false);
      }

      this.$router.push(this.group.routes[0].path);
      this.$emit('changeFocusedId', this.group.id);
      return;
    }

    this.$emit('click-collapse', this.group.id);
  }

  clickCollapseSubGroup(data: { id: string; opened: boolean }) {
    if (data.id === getCurrentGroup().id || data.opened) {
      this.$emit('changeFocusedId', data.id);
    } else {
      let id: any = this.group.id;

      if (getCurrentGroup().id === this.group.id) id = getCurrentRoute().name;

      this.$emit('changeFocusedId', id);
    }
  }
}
